import React from 'react';

const UmbrellaIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M12 12v7a2 2 0 0 0 4 0" />
    <path d="M5 12a7 7 0 0 1 14 0Z" />
    <path d="M12 2v1" />
  </svg>
);

export default UmbrellaIcon;
